module.exports = __webpack_public_path__ + "assets/img/loading.078fcd09.gif";